<template>
  <UserDocumentsList
    :documents="store.documents"
    :available-types="availableDocumentTypes"
    :hide-upload="isUploadHidden"
    :on-download="onDownload"
    :on-upload="uploadFile"/>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import { SOLO_TRADER_DOCUMENTS, TWO_SIDE_DOCUMENTS } from '@/constants';
import { useCustomerProfileInject } from '@/modules/onboarding-dashboard/shared/utils';
import UserDocumentsList from '@/modules/onboarding-user-profile/components/user-documents-list.vue';
import {
  useOnboardingAdminSoleTraderStore,
} from '@/stores/onboarding/OnboardingAdminSoleTrader';
import { CorporateDocumentType, DocumentSide } from '@/types/interfaces/Document.interface';

const store = useOnboardingAdminSoleTraderStore();
const { isApplicationEditable } = useCustomerProfileInject();

const isSoleTraderDetailsFilled = computed(() => store.completedStages.includes('SOLE_TRADER_DETAILS'));
const isUploadHidden = computed(() => !(isApplicationEditable.value && isSoleTraderDetailsFilled.value));

const availableDocumentTypes = computed(() => SOLO_TRADER_DOCUMENTS.map((document) => {
  if (TWO_SIDE_DOCUMENTS.includes(document as typeof TWO_SIDE_DOCUMENTS[0])) {
    return [`${document}_FRONT`, `${document}_BACK`];
  }
  return [document];
}).flat());

async function onDownload(type: CorporateDocumentType, side: DocumentSide): Promise<Blob | undefined> {
  const { response, error } = await store.documentsHandler.get({ type, side });
  return error !== null ? undefined : response;
}

const uploadFile = async (fileData: {
  type: CorporateDocumentType;
  formData: FormData;
  issuingCountryIso3?: string;
  side?: DocumentSide;
}) => {
  await store.uploadDocument(fileData);
};
</script>
